<template>
  <NavigationBar/>
  <router-view/>
  <FooterBox />
</template>

<script type="ts" src="./App.ts"></script>
<style lang="sass" src="./App.sass" ></style>
